import React from 'react'
import PropTypes from 'prop-types'
import CodeForm from './CodeForm'
import CustomScrollBar from '../../../../shared/CustomScrollBar'
import { FILTER_CODE } from '../../../constants'
import './code.scss'

const ProfessionalCode = ({
  titles, codeChange, filterApplyAction, activeField, values, validate, syncErrors,
}) => {
  const {
    form: {
      title, subTitle, labels, placeholders, titleCode,
    },
  } = titles

  const codeChangeHandle = (...args) => {
    codeChange(args[3], args[1])
    filterApplyAction(FILTER_CODE, false)
  }


  return (
    <div className="filter-code">
        <CustomScrollBar>
          <div className="filter-code__title">
            {title}
            <div>
              {titleCode}
            </div>
          </div>
          <div className="filter-code__sub-title">
            {subTitle}
          </div>
          {values && values.error ? (
            <div className="filter-code__sub-title filter-code__error">
              {values.error}
            </div>
          ) : null }
          {values && !values.error && values.wrongPromoCode ? (
            <div className="filter-code__sub-title filter-code__error">
              {values.wrongPromoCodeMessage}
            </div>
          ) : null }
          <CodeForm
            labels={labels}
            placeholders={placeholders}
            codeChange={codeChangeHandle}
            activeField={activeField}
            values={values}
            validate={validate}
            syncErrors={syncErrors}
          />
        </CustomScrollBar>
    </div>
  )
}

ProfessionalCode.propTypes = {
  titles: PropTypes.objectOf(Object).isRequired,
  codeChange: PropTypes.func.isRequired,
  filterApplyAction: PropTypes.func.isRequired,
  activeField: PropTypes.string,
  values: PropTypes.objectOf(Object),
  validate: PropTypes.arrayOf(PropTypes.func).isRequired,
  syncErrors: PropTypes.objectOf(PropTypes.string),
}

ProfessionalCode.defaultProps = {
  activeField: '',
  values: null,
  syncErrors: {},
}
export default ProfessionalCode
